export default "__VITE_ASSET__Canz41U___"